// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"d675ff52","897":"a8cc6f3d"}[chunkId] + ".chunk.js";
};